import React, {useEffect, useState} from 'react';
import {LuArrowUp} from 'react-icons/lu';

export default function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', toggleVisibility, {passive: true});
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
    };

    return (
        <div>
            {isVisible && (
                <button type="button" onClick={scrollToTop} className="ak-round-btn scroll-to-top" style={{maxWidth: 120}}>
                    Top
                    <LuArrowUp aria-hidden="true"/>
                </button>
            )}
        </div>
    );
}
